let isButtonInitialized = false;

export function initializeEmailButton() {
  if (isButtonInitialized || document.getElementById('custom-email-float')) return;

  const url = "https://contact.pogustgoodhead.com/";

  // Create style tag
  const style = document.createElement('style');
  style.textContent = `
    #custom-email-float {
      position: fixed;
      bottom: 20px;
      right: 20px;
      background-color: #444444;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 9999;
      transition: transform 0.2s ease;
    }
    #custom-email-float:hover {
      transform: scale(1.1);
    }
    #custom-email-float img {
      width: 28px;
      height: 28px;
    }
  `;
  document.head.appendChild(style);

  // Create the floating button
  const btn = document.createElement('div');
  btn.id = 'custom-email-float';
  btn.innerHTML = `
    <img src="https://img.icons8.com/ios-filled/50/ffffff/new-post.png" alt="Email Icon" />
  `;

  btn.addEventListener('click', () => {
    window.open(url, '_blank');
  });

  document.body.appendChild(btn);
  isButtonInitialized = true;
}
